import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoFilialesFilialComponent {
  constructor(FanProyectoFilialesFilialService) {
    this.FanProyectoFilialesFilialService = FanProyectoFilialesFilialService
    this.idProyecto = undefined
    this.data = undefined
    this.onDelete = undefined
    this.onChange = undefined
    this.actualizando = false
    this.actualizar = this.actualizar.bind(this)
    this.eliminar = this.eliminar.bind(this)
  }

  $onChanges(changes) {
    if (changes && changes.data) {
      this.data = angular.copy(changes.data.currentValue)
    }
  }

  actualizar() {
    this.data.Master = true
    this.actualizando = true

    return this.FanProyectoFilialesFilialService.put(this.idProyecto, this.data.ID_Cliente, this.data)
      .then(() => (this.onChange({$event: {data: this.data}})))
      .finally(() => (this.actualizando = false))
  }

  eliminar() {
    if (this.actualizando) return

    this.actualizando = true

    return this.FanProyectoFilialesFilialService.delete(this.idProyecto, this.data.ID_Cliente)
      .then(() => (this.onDelete()))
      .finally(() => (this.actualizando = false))
  }
}

module.component('fanProyectoFilialesFilial', {
  controller: FanProyectoFilialesFilialComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    data: '<',
    onDelete: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/filiales/filial/component.js